import React from 'react'
import './BottomNav.css'

import logoImage from '@/assets/lnxdigi_logo_new.png'

export interface BottomNavProps {
  className?: string
}

export const BottomNav: React.FC<BottomNavProps> = ({ className = '' }) => {
  return (
    <footer className={`bottom-nav ${className}`}>
      <div className="bottom-nav-left">
        <div className="bottom-nav-logo">
          <img src={logoImage} alt="Launchyx Digital" className="bottom-nav-logo-image" />
        </div>
        <nav className="bottom-nav-copyright">
          <span>©</span>
          <span>2026 Launchyx Digital,Inc</span>
        </nav>
      </div>
    </footer>
  )
}
